import { IVersionedChoice, PropertySheet, PropertySheetCategory, TypedCardElementPeer } from "adaptivecards-designer";
import {  getPropertyEditorInstance, PickerBase, PropertyKeys } from "./PickerBase";
import {  removeOtherPropertyConfigurations } from "../Utils/CustomElementUtils";
export class CategoryPicker extends PickerBase{
    static readonly JsonTypeName = "Category";
    static readonly ElementId = "Ticket.Category";
    static readonly defaultLabel = "Category";
    static pickerChoices: any[];

    protected internalRender(): HTMLElement | undefined {
        this.id = CategoryPicker.ElementId;
        if((this?.displayLabel ?? "").length == 0)
            this.displayLabel = CategoryPicker.defaultLabel;

        if(CategoryPicker.pickerChoices){
            this.displayChoices = CategoryPicker.pickerChoices;
        }

        return super.internalRender();
    }
    
    getJsonTypeName(): string {
        return CategoryPicker.JsonTypeName;
    }
}

export class CategoryPickerPeer extends TypedCardElementPeer<CategoryPicker> {
    static displayLabelProperty = getPropertyEditorInstance(CategoryPicker.ElementId, PropertyKeys.displayLabel);
    static requireFieldProperty = getPropertyEditorInstance(CategoryPicker.ElementId, PropertyKeys.requireField);
    static dataSourceProperty = getPropertyEditorInstance(CategoryPicker.ElementId, PropertyKeys.dataSource, []);

    static updateChoices(choices: IVersionedChoice[]) {
        this.dataSourceProperty = getPropertyEditorInstance(CategoryPicker.ElementId, PropertyKeys.dataSource, choices);
    }

    populatePropertySheet(propertySheet: PropertySheet, defaultCategory: string = PropertySheetCategory.DefaultCategory) {
        
        super.populatePropertySheet(propertySheet, defaultCategory);
        removeOtherPropertyConfigurations(propertySheet);
        
        propertySheet.add(
            defaultCategory,
            CategoryPickerPeer.idProperty,
            CategoryPickerPeer.displayLabelProperty,
            CategoryPickerPeer.requireFieldProperty,
            CategoryPickerPeer.dataSourceProperty);
    
    }
}

